import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  '@global': {
    footer: {
      borderTop: `1px solid ${theme.palette.grey[300]}`
    }
  },
  root: {
    zIndex: 1010,
    paddingLeft: 10,
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 40,
    backgroundColor: theme.backgroundColor
  },
  img: {
    width: 30,
    height: 30
  },
  span: {
    fontSize: '9pt',
    color: theme.palette.text.primary,
    paddingTop: 3
  },
  copyright: {
    position: 'relative',
    top: -25,
    textAlign: 'center',
    fontSize: '10pt',
    //color: theme.palette.primary.contrastText,
    marginLeft: 150,
    marginRight: 150
  }
}))

export {
  useStyles
}
